module.exports = __webpack_public_path__ + "static/media/oregon.c6036271.svg";